<template>
  <mdb-container fluid>
    <mdb-row>
      <mdb-col>
        <dt-auto-complete
          :items="searchData"
          @selected="search($event)"
          @cleared="resetFilters()"
        ></dt-auto-complete>
      </mdb-col>
    </mdb-row>
  </mdb-container>
</template>

<script>
import DtAutoComplete from "./DtAutoComplete";
import {
  getCountries,
  getOperators,
  getServices
} from "../common/dataSourceIntegrationService.js";
import { applyFilter } from "../common/utilities/mapController.js";

export default {
  name: "SearchWithAutoComp",

  components: {
    DtAutoComplete
  },
  created() {
    getCountries().forEach(country => {
      this.countries.push(country.name);
    });
    getServices().forEach(service => {
      this.services.push(service.name);
    });
    getOperators().forEach(operator => {
      this.operators.push(operator.name);
    });
    new Set(
      new Array()
        .concat(this.countries)
        .concat(this.services)
        .concat(this.operators)
        .sort()
    ).forEach(item => {
      this.searchData.push(item);
    });
  },
  data() {
    return {
      mapFilters: this.$store.getters.mapFilters,
      lastSelectedValue: null,
      countries: [],
      services: [],
      operators: [],
      searchData: []
    };
  },
  methods: {
    getIsoCodeFromName(countryName) {
      let isoCode;
      getCountries().forEach(country => {
        if (country.name == countryName) {
          isoCode = country["iso_code"];
        }
      });
      return isoCode;
    },
    search(selectedValue) {
      this.lastSelectedValue = selectedValue;
      if (this.countries.includes(selectedValue)) {
        let selectedIsoCode = this.getIsoCodeFromName(selectedValue);
        this.mapFilters["countries"] = [selectedIsoCode];
      } else if (this.services.includes(selectedValue)) {
        this.mapFilters["services"] = [selectedValue];
      } else if (this.operators.includes(selectedValue)) {
        this.mapFilters["operators"] = [selectedValue];
      }
      applyFilter(this.mapFilters);
      this.$emit("changed");
    },
    resetFilters() {
      if (this.countries.includes(this.lastSelectedValue)) {
        let selectedIsoCode = this.getIsoCodeFromName(this.lastSelectedValue);
        this.mapFilters.countries.pop(
          this.mapFilters.countries.indexOf(selectedIsoCode)
        );
      } else if (this.services.includes(this.lastSelectedValue)) {
        this.mapFilters.services.pop(
          this.mapFilters.services.indexOf(this.lastSelectedValue)
        );
      } else if (this.operators.includes(this.lastSelectedValue)) {
        this.mapFilters.operators.pop(
          this.mapFilters.operators.indexOf(this.lastSelectedValue)
        );
      }
      applyFilter(this.mapFilters);
      this.$emit("changed");
    }
    // resetFilters() {
    //   //this.$store.commit("resetMapFilters");
    //   console.log(this.mapFiltersLastState, this.mapFilters);
    //   applyFilter(this.mapFilters);
    //   this.$emit("changed");
    // }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
